import axios from 'axios';
import { useAuth } from '../components/Auth/AuthContext.tsx';
import { useCallback } from 'react';

// const baseURL = process.env.REACT_APP_API_URL;
// const baseURLUsers = process.env.REACT_APP_API_URL_USERS;
// const apikey = process.env.REACT_APP_API_KEY;

const baseURL = window.REACT_APP_API_URL || "https://hoytoca2025-recipe-service.prd.cloudherdez.com";
const baseURLUsers = window.REACT_APP_API_URL_USERS || "https://hoytoca2025-user-service.prd.cloudherdez.com";
const apikey = window.API_KEY || "HoyToca-Secret-2025~Di56m1-6BZWu6e+h>C";

export const useApi = () => {
  const { token } = useAuth();

  // Solicitudes genéricas
  const ApiRequest = useCallback(async (
    endpoint: string,
    method: string = 'GET',
    data: any = null,
    isLogin: boolean = false,
    responseType: string = 'json'
  ) => {
    try {
      

      const config: any = {
        method,
        url: `${isLogin ? baseURLUsers : baseURL}/${endpoint}`,
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': apikey,
        },
        responseType,
      };

      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }

      if (method !== 'GET' && data) {
        config.data = data;
      }

      const response = await axios(config);

      if (responseType === 'blob') {
        return response.data;
      }
      
      return response.data;
    } catch (error) {
      console.error(`Error:: during ${method} request to ${endpoint}:`, error);
      return error.response?.data || { error: 'Unknown error occurred' };
    }
  }, [token]);

  // Solicitud específica para activaciones
  const ApiRequestActivation = async (
    endpoint: string,
    method: string = 'GET',
    activationToken: string
  ) => {
    try {
      const config: any = {
        method,
        url: `${baseURLUsers}/${endpoint}`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${activationToken}`, // Siempre usa el token de activación
          'x-api-key': apikey,
          'Origin': window.location.origin
        },
      };

      const response = await axios(config);
      return response.data;
    } catch (error) {
      console.error(`Error:: during ${method} request to ${endpoint}:`, error);
      return error.response?.data || { error: 'Unknown error occurred' };
    }
  };

  return { ApiRequest, ApiRequestActivation };
};
